exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dates[data-v-caaa5882] {\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.buttons[data-v-caaa5882] {\n  justify-content: space-between;\n}\n.message[data-v-caaa5882] {\n  justify-content: space-between;\n}\n.loading-counter[data-v-caaa5882] {\n  z-index: 10005;\n  position: fixed;\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.content-filters .cof-box[data-v-caaa5882] {\n  background: none;\n}\n.content-tlist[data-v-caaa5882] {\n  border: none;\n}", ""]);

// exports
